import { render } from "./SectionAside.vue?vue&type=template&id=2213cd2c&scoped=true"
import script from "./SectionAside.vue?vue&type=script&lang=js"
export * from "./SectionAside.vue?vue&type=script&lang=js"

import "./SectionAside.vue?vue&type=style&index=0&id=2213cd2c&lang=scss&scoped=true"
import "./SectionAside.vue?vue&type=style&index=1&id=2213cd2c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2213cd2c"]])

export default __exports__